export interface ILoginObjType {
  userID: string;
  accTyp: string;
  pwd: string;
}

export interface IVendorLogin {
  ottype: string;
  vsource: string;
  sourcetoken: string;
  isbasket?: string;
  data?: any;
  sTab?: string;
}

export enum ForgotPasswordScreenEnum {
  FORGOT_PASSWORD,
  OTP_SCREEN,
  RESET_OTP_PASSWORD,
  RESET_PASSWORD,
  EQUITY_STATUS_SCREEN,
  COMMODITY_STATUS_SCREEN,
}
